import { HttpErrorResponse } from "@angular/common/http";
import { LearningPlan } from "src/app/_models/LearningPlan";
import { LearningPlanActivity } from "src/app/_models/LearningPlanActivity";
import { ManualLearningPlanResultDto } from "src/app/_models/ManualLearningPlanResultDto";

export interface LearningPlanState {
	course: number;
	panelState: LearningPlan[];
	allowPopUp: boolean;
	loader: boolean;
	result: LearningPlan[];
	error: any;
	active: LearningPlanActivity;
	reminders: LearningPlan[];

	editLearningPlanLoader: boolean;
	editLearningPlanError: HttpErrorResponse;
	editLearningPlanResult: boolean | null
	manualLearningPlan: ManualLearningPlanResultDto[];
	isManualLearningPlanSuccess: boolean;
	manualLearningPlanLoader: boolean;
}

export const initialLearningPlanState : LearningPlanState = {
	course: 0,
	panelState: [],
	allowPopUp: true,
	result: [],
	loader: false,
	error: null,
	active: null,
	reminders: [],
	editLearningPlanError: null,
	editLearningPlanLoader: false,
	editLearningPlanResult: null,
	manualLearningPlan: [],
	isManualLearningPlanSuccess: false,
	manualLearningPlanLoader: false
}